module.exports = __webpack_public_path__ + "static/media/Ubuntu Italic-01.69063db8.svg";